import ReceiptsList from './receipts-list';

export default ReceiptsList;
